import React from "react";
import SeoMeta from "../components/meta/index.jsx";
import BikeSearchResult from "../components/bikeSearchResult/searchResult.jsx";

export default function BikeSearch() {
  return (
    <>
      <SeoMeta
        title="Search Used Bikes | FameWheels"
        desc="Find Reliable and Affordable used bikes in Excellent Condition at our dealership. we are choose from  large selection of automobiles here to find the perfect used bikes today."
        url="search"
      />

      <BikeSearchResult />
    </>
  );
}
